@import "stylesheets/sdx/typography/typography";
@import "stylesheets/sdx/utilities/screenreaders";
@import "stylesheets/sdx/mixins/gradient";

.component {
  @include typo-headline-5;
  @include font-semi-bold;
  white-space: nowrap;
  width: fit-content;
  color: $color-white;
  display: flex;
  border-radius: $border-radius;
  gap: $baseline;

  &.orchid {
    @include gradient-orchid;
  }

  &.horizon {
    @include gradient-horizon-light;
    color: $color-sc-navy;
  }

  .unit {
    @include typo-small;
    @include font-semi-light;
    line-height: $baseline-2 * 1.5;
  }

  &.small {
    height: $baseline-4;
    padding: $baseline * 0.5 $baseline * 1.5;

    .unit-wrapper {
      display: flex;
      align-items: center;
      gap: $baseline * 0.5;
      line-height: $baseline-3;
      @include font-semi-bold;

      .number {
        @include typo-headline-5;
      }
    }
  }

  &.large {
    padding: $baseline * 0.5 $baseline-2;
    font-size: 24px;
    .unit-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: $baseline * 0.5;
      height: fit-content;
      width: 38px;
      .number {
        @include font-semi-bold;
        line-height: $baseline-3;
      }
    }

    .separator {
      @include font-bold;
      letter-spacing: -0.2px;
    }
  }
}

.component.horizon.sdx--dark-theme {
  @include gradient-horizon-dark;
  color: $color-white;
}
